import Future from 'fluture';
import cookies from 'browser-cookies';
import * as r from 'ramda';

export default function createOptOut(

) {
  return function OptOut(
    ids,
    expires,
  ) {
    const cookieValue = r.pipe(
      r.values,
      r.map((id) => `${id}:1`),
      r.prepend('0:1'),
      r.join('|'),
    )(ids);

    cookies.set(
      'OPTOUTMULTI',
      cookieValue,
      {
        secure: false,
        expires,
        domain: window.utag.cfg.domain,
      },
    );

    return Future.of(true);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/optOut.js